import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetHealth = z.any()
export type TagsGetHealth = z.infer<typeof tagsGetHealth>

export const descriptionGetHealth = z.any()
export type DescriptionGetHealth = z.infer<typeof descriptionGetHealth>

export const responseGetHealth = z.object({ "status": z.literal("ok"), "timestamp": z.string().datetime({ offset: true }) })
export type ResponseGetHealth = z.infer<typeof responseGetHealth>

interface IGetHealth extends BaseMethodType {
  tags: TagsGetHealth,
  description: DescriptionGetHealth,
  response: ResponseGetHealth
}
export const URL = '/health'
export const validation = {
  get: {
    tags: tagsGetHealth,
    description: descriptionGetHealth,
    response: responseGetHealth
  }
}
export interface Health extends BaseRouteType {
  get: IGetHealth
}